export default __webpack_public_path__ + "static/media/vera.140cfb6a.jpg";